module.exports = __webpack_public_path__ + "static/baked_maracon_halloween-b1d4bc666c3ea67c4a67189f377808c9.jpg";